const availableAnalytics = [
  {
    name: 'sitecatalyst',
    nonprod: 'https://tms.capitalone.com/capitalone/dev/Bootstrap.js',
    prod: 'https://tms.capitalone.com/capitalone/prod/Bootstrap.js',
  },
  {
    name: 'potomac',
    nonprod: 'https://tms.capitalone.com/capitalone/dev/Bootstrap.js',
    prod: 'https://tms.capitalone.com/capitalone/prod/Bootstrap.js',
  },
];

export { availableAnalytics };
